import React from "react";
import * as styles from "./OneThirdTwoThirdSummaryDisplay.module.css";
import { ComponentProps, ComponentWidth } from "../../../types";
import {
  SummaryTile,
  SummaryTileProps,
} from "../../elements/SummaryTile/SummaryTile";
import { SectionWrapper } from "../../containers/SectionWrapper";

interface Props extends ComponentProps, ComponentWidth {
  summaries: SummaryTileProps[];
  tileLayout: string;
}

export const OneThirdTwoThirdSummaryDisplay: React.FC<Props> = ({
  summaries,
  width,
  tileLayout,
  ...props
}) => {
  const sectionWidthStyles =
    width === "contained"
      ? `${styles.summaries} ${styles.contained}`
      : styles.summaries;

  if (!summaries) return null;

  return (
    <SectionWrapper {...props}>
      <div
        className={sectionWidthStyles}
        data-kontent-element-codename="content_tiles"
      >
        <SummaryTile
          {...summaries[0]}
          tileWidth={
            tileLayout === "onethird_twothird" ? "oneThird" : "twoThirds"
          }
        />
        {summaries[1] && (
          <SummaryTile
            {...summaries[1]}
            tileWidth={
              tileLayout === "onethird_twothird" ? "twoThirds" : "oneThird"
            }
          />
        )}
      </div>
    </SectionWrapper>
  );
};
